import { useEffect } from 'react'
import Header from "../src/components/nav/Header"
import Home from "../src/pages/Home"
import About from "../src/pages/About"
import Footer from "../src/components/nav/Footer"
import { Switch, Route } from 'react-router-dom'
import Login from "../src/pages/Login"
import Agreement from "./pages/Agreement"
import Signup from "./pages/Signup"
import Register from "./pages/Register"
import MyPage from "./pages/MyPage"
import Posts from "./pages/Posts"
import Generals from "./pages/Generals"
import WritePost from "./pages/WritePost"
import WriteGeneral from "./pages/WriteGeneral"
import myPage from "./pages/MyPage"
import Tips from "./pages/Tips"
import Notices from "./pages/Notices"
import Contents from "./pages/Contents"
import MyPost from "./pages/MyPost"
import MyGeneral from "./pages/MyGeneral"
import { ToastContainer } from 'react-toastify'
import { useDispatch } from 'react-redux'
import { personalinfo, loginCheck } from "../src/functions/auth"
import MySearch from "./pages/MySearch"
import "react-toastify/dist/ReactToastify.css"
function App() {

  const dispatch = useDispatch()

  useEffect(() => {
    const currentUser = async () => {
      try {
        const user = await personalinfo()
        dispatch({
          type: "LOGGED_IN_USER",
          payload: {
            userID: user.userID,
            name: user.name
          }
        })
      } catch (e) {
        console.log(e)
      }
    }
    if (loginCheck()) {
      currentUser()
    } else {
      dispatch({
        type: "LOGOUT",
        payload: null
      })
    }
  }, [dispatch])

  return (
    <>
      <Header />
      <ToastContainer />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/about" component={About} />
        <Route exact path="/login" component={Login} />
        <Route exact path="/agreement" component={Agreement} />
        <Route exact path="/signup" component={Signup} />
        <Route exact path="/register" component={Register} />
        <Route exact path="/mypage" component={MyPage} />
        <Route exact path="/post" component={Posts} />
        <Route exact path="/general" component={Generals} />
        <Route exact path="/write/post" component={WritePost} />
        <Route exact path="/write/general" component={WriteGeneral} />
        <Route exact path="/tip" component={Tips} />
        <Route exact path="/mypage" component={myPage} />
        <Route exact path="/notice" component={Notices} />
        <Route exact path="/content" component={Contents} />
        <Route exact path="/mypage/mypost" component={MyPost} />
        <Route exact path="/mypage/mygeneral" component={MyGeneral} />
        <Route exact path="/mysearch" component={MySearch} />
      </Switch>
      <Footer />
    </>
  );
}

export default App;
